(() => {
  if (window.__nodaraQuickAddInitialized) {
    return;
  }

  window.__nodaraQuickAddInitialized = true;

  class NodaraQuickAdd extends HTMLElement {
    constructor() {
      super();

      this.trigger = null;
      this.dataElement = null;
      this.productData = null;
    }

    connectedCallback() {
      this.trigger = this.querySelector(
        '[data-nd-quick-add-trigger]'
      );

      this.dataElement = this.querySelector(
        '[data-nd-quick-add-data]'
      );

      if (
        !this.trigger
        || !this.dataElement
      ) {
        return;
      }

      try {
        this.productData =
          JSON.parse(
            this.dataElement.textContent
          );
      } catch (error) {
        console.error(
          '[Nodara Quick Add] Error leyendo producto.',
          error
        );

        return;
      }

      this.trigger.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          NodaraQuickAddModal.open(
            this.productData
          );
        }
      );
    }
  }


  class NodaraQuickAddModal {
    static modal = null;

    static data = null;

    static selectedOptions = [];

    static currentVariant = null;

    static lastTrigger = null;


    /* =====================================================
       OPEN
    ===================================================== */

    static open(data) {
      if (!data) {
        return;
      }

      this.data =
        data;

      this.lastTrigger =
        document.activeElement;

      this.ensureModal();

      this.render();

      this.modal.hidden =
        false;

      this.modal.setAttribute(
        'aria-hidden',
        'false'
      );

      this.modal.classList.add(
        'is-open'
      );

      document.documentElement.classList.add(
        'nd-quick-add-open'
      );

      document.body.classList.add(
        'nd-quick-add-open'
      );

      requestAnimationFrame(
        () => {
          this.modal
            .querySelector(
              '[data-nd-quick-add-close]'
            )
            ?.focus();
        }
      );
    }


    /* =====================================================
       CLOSE
    ===================================================== */

    static close() {
      if (!this.modal) {
        return;
      }

      this.modal.classList.remove(
        'is-open'
      );

      this.modal.setAttribute(
        'aria-hidden',
        'true'
      );

      this.modal.hidden =
        true;

      document.documentElement.classList.remove(
        'nd-quick-add-open'
      );

      document.body.classList.remove(
        'nd-quick-add-open'
      );

      const trigger =
        this.lastTrigger;

      this.lastTrigger =
        null;

      if (
        trigger
        && typeof trigger.focus === 'function'
      ) {
        requestAnimationFrame(
          () => {
            trigger.focus();
          }
        );
      }
    }


    /* =====================================================
       CREATE MODAL
    ===================================================== */

    static ensureModal() {
      if (this.modal) {
        return;
      }

      const modal =
        document.createElement(
          'div'
        );

      modal.className =
        'nd-quick-add-modal';

      modal.hidden =
        true;

      modal.setAttribute(
        'aria-hidden',
        'true'
      );

      modal.innerHTML = `
        <div
          class="nd-quick-add-modal__backdrop"
          data-nd-quick-add-close
        ></div>

        <div
          class="nd-quick-add-modal__dialog"
          role="dialog"
          aria-modal="true"
          aria-label="Elegir opciones"
        >
          <button
            type="button"
            class="nd-quick-add-modal__close"
            data-nd-quick-add-close
            aria-label="Cerrar"
          >
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            >
              <path d="M6 6l12 12"></path>
              <path d="M18 6L6 18"></path>
            </svg>
          </button>

          <div
            class="nd-quick-add-modal__content"
            data-nd-quick-add-content
          ></div>
        </div>
      `;

      document.body.appendChild(
        modal
      );

      modal
        .querySelectorAll(
          '[data-nd-quick-add-close]'
        )
        .forEach(
          (element) => {
            element.addEventListener(
              'click',
              () => {
                this.close();
              }
            );
          }
        );

      document.addEventListener(
        'keydown',
        (event) => {
          if (
            event.key === 'Escape'
            && this.modal
            && !this.modal.hidden
          ) {
            this.close();
          }
        }
      );

      this.modal =
        modal;
    }


    /* =====================================================
       RENDER
    ===================================================== */

    static render() {
      const content =
        this.modal.querySelector(
          '[data-nd-quick-add-content]'
        );

      if (
        !content
        || !this.data
      ) {
        return;
      }

      const initialVariant =
        this.data.variants.find(
          (variant) =>
            String(
              variant.id
            )
            === String(
              this.data.initialVariantId
            )
        )
        || this.data.variants.find(
          (variant) =>
            variant.available
        )
        || this.data.variants[0];

      this.currentVariant =
        initialVariant;

      this.selectedOptions =
        Array.isArray(
          initialVariant?.options
        )
          ? [...initialVariant.options]
          : [];

      content.innerHTML = `
        <div class="nd-quick-add-modal__product">

          <div class="nd-quick-add-modal__media">
            ${
              this.data.featuredImage
                ? `
                  <img
                    src="${this.escapeHtml(
                      this.data.featuredImage
                    )}"
                    alt=""
                    data-nd-quick-add-image
                  >
                `
                : ''
            }
          </div>

          <div class="nd-quick-add-modal__info">

            <div class="nd-quick-add-modal__eyebrow">
              OFFSIDE
            </div>

            <a
              href="${this.escapeHtml(
                this.data.url
              )}"
              class="nd-quick-add-modal__title"
            >
              ${this.escapeHtml(
                this.data.title
              )}
            </a>

            <div
              class="nd-quick-add-modal__price"
            >
              <span
                class="nd-quick-add-modal__price-current"
                data-nd-quick-add-price
              ></span>

              <span
                class="nd-quick-add-modal__price-compare"
                data-nd-quick-add-compare
                hidden
              ></span>
            </div>

            <div
              class="nd-quick-add-modal__options"
              data-nd-quick-add-options
            >
              ${this.renderOptions()}
            </div>

            <div
              class="nd-quick-add-modal__selected"
            >
              Seleccionado:
              <strong
                data-nd-quick-add-selected
              ></strong>
            </div>

            <button
              type="button"
              class="nd-quick-add-modal__add"
              data-nd-quick-add-add
            >
              <span data-nd-quick-add-add-text>
                Agregar al carro
              </span>

              <span
                class="nd-quick-add-modal__spinner"
                data-nd-quick-add-spinner
                hidden
              ></span>
            </button>

            <a
              href="${this.escapeHtml(
                this.data.url
              )}"
              class="nd-quick-add-modal__view"
            >
              Ver producto completo →
            </a>

          </div>

        </div>
      `;

      this.bindOptionEvents();
      this.bindAddEvent();

      this.updateUI();
    }


    /* =====================================================
       OPTIONS
    ===================================================== */

    static renderOptions() {
      return this.data.options
        .map(
          (
            option,
            optionIndex
          ) => {

            /*
             * Orden visual OFFSIDE.
             */

            let values =
              [...option.values];

            const normalizedName =
              String(
                option.name
              )
                .toLowerCase()
                .trim();

            if (
              normalizedName.includes(
                'tamaño'
              )
              || normalizedName.includes(
                'tamano'
              )
            ) {
              const sizeOrder = [
                '30x40',
                '40x50',
                '50x70'
              ];

              values.sort(
                (
                  a,
                  b
                ) => {
                  const normalizedA =
                    this.normalizeSize(
                      a
                    );

                  const normalizedB =
                    this.normalizeSize(
                      b
                    );

                  return (
                    sizeOrder.indexOf(
                      normalizedA
                    )
                    -
                    sizeOrder.indexOf(
                      normalizedB
                    )
                  );
                }
              );
            }

            if (
              normalizedName.includes(
                'color'
              )
            ) {
              const colorOrder = [
                'negro',
                'madera',
                'blanco'
              ];

              values.sort(
                (
                  a,
                  b
                ) => {
                  return (
                    colorOrder.indexOf(
                      String(a)
                        .toLowerCase()
                        .trim()
                    )
                    -
                    colorOrder.indexOf(
                      String(b)
                        .toLowerCase()
                        .trim()
                    )
                  );
                }
              );
            }

            return `
              <div
                class="nd-quick-add-option"
                data-option-index="${optionIndex}"
              >
                <div
                  class="nd-quick-add-option__label"
                >
                  ${this.escapeHtml(
                    option.name
                  )}

                  <span
                    data-nd-quick-add-option-selected="${optionIndex}"
                  ></span>
                </div>

                <div
                  class="nd-quick-add-option__values"
                >
                  ${values
                    .map(
                      (value) => `
                        <button
                          type="button"
                          class="nd-quick-add-option__button"
                          data-nd-quick-add-option
                          data-option-index="${optionIndex}"
                          data-option-value="${this.escapeHtml(
                            value
                          )}"
                        >
                          ${this.escapeHtml(
                            value
                          )}
                        </button>
                      `
                    )
                    .join('')}
                </div>
              </div>
            `;
          }
        )
        .join('');
    }


    static bindOptionEvents() {
      this.modal
        .querySelectorAll(
          '[data-nd-quick-add-option]'
        )
        .forEach(
          (button) => {
            button.addEventListener(
              'click',
              () => {
                const index =
                  Number(
                    button.dataset
                      .optionIndex
                  );

                const value =
                  button.dataset
                    .optionValue;

                this.handleOptionChange(
                  index,
                  value
                );
              }
            );
          }
        );
    }


    static handleOptionChange(
      optionIndex,
      value
    ) {
      this.selectedOptions[
        optionIndex
      ] =
        value;

      let variant =
        this.findVariant(
          this.selectedOptions
        );

      if (
        !variant
        || !variant.available
      ) {
        const fallback =
          this.findFallbackVariant(
            optionIndex,
            value
          );

        if (fallback) {
          variant =
            fallback;

          this.selectedOptions =
            [...fallback.options];
        }
      }

      this.currentVariant =
        variant;

      this.updateUI();
    }


    /* =====================================================
       VARIANT
    ===================================================== */

    static findVariant(options) {
      return (
        this.data.variants.find(
          (variant) => {
            return variant.options.every(
              (
                option,
                index
              ) =>
                option
                === options[index]
            );
          }
        )
        || null
      );
    }


    static findFallbackVariant(
      changedIndex,
      changedValue
    ) {
      const available =
        this.data.variants.filter(
          (variant) =>
            variant.available
        );

      return (
        available.find(
          (variant) =>
            variant.options[
              changedIndex
            ]
            === changedValue
        )
        || available[0]
        || null
      );
    }


    /* =====================================================
       UPDATE UI
    ===================================================== */

    static updateUI() {
      const variant =
        this.currentVariant;

      if (!variant) {
        return;
      }

      this.modal
        .querySelectorAll(
          '[data-nd-quick-add-option]'
        )
        .forEach(
          (button) => {
            const index =
              Number(
                button.dataset
                  .optionIndex
              );

            const selected =
              button.dataset
                .optionValue
              === this.selectedOptions[
                index
              ];

            button.classList.toggle(
              'is-selected',
              selected
            );
          }
        );

      this.data.options.forEach(
        (
          option,
          index
        ) => {
          const selectedLabel =
            this.modal.querySelector(
              `[data-nd-quick-add-option-selected="${index}"]`
            );

          if (selectedLabel) {
            selectedLabel.textContent =
              this.selectedOptions[
                index
              ]
              || '';
          }
        }
      );

      const selected =
        this.modal.querySelector(
          '[data-nd-quick-add-selected]'
        );

      if (selected) {
        selected.textContent =
          this.selectedOptions
            .filter(Boolean)
            .join(' · ');
      }

      const price =
        this.modal.querySelector(
          '[data-nd-quick-add-price]'
        );

      if (price) {
        price.textContent =
          this.formatMoney(
            variant.price
          );
      }

      const compare =
        this.modal.querySelector(
          '[data-nd-quick-add-compare]'
        );

      if (compare) {
        const comparePrice =
          Number(
            variant.compareAtPrice
            || 0
          );

        if (
          comparePrice
          > Number(
            variant.price
          )
        ) {
          compare.hidden =
            false;

          compare.textContent =
            this.formatMoney(
              comparePrice
            );
        } else {
          compare.hidden =
            true;

          compare.textContent =
            '';
        }
      }

      const image =
        this.modal.querySelector(
          '[data-nd-quick-add-image]'
        );

      if (
        image
        && variant.image
      ) {
        image.src =
          variant.image;
      }

      const addButton =
        this.modal.querySelector(
          '[data-nd-quick-add-add]'
        );

      const addText =
        this.modal.querySelector(
          '[data-nd-quick-add-add-text]'
        );

      if (addButton) {
        addButton.disabled =
          !variant.available;
      }

      if (addText) {
        addText.textContent =
          variant.available
            ? 'Agregar al carro'
            : 'Agotado';
      }

      this.updateAvailability();
    }


    /* =====================================================
       AVAILABILITY
    ===================================================== */

    static updateAvailability() {
      this.modal
        .querySelectorAll(
          '[data-nd-quick-add-option]'
        )
        .forEach(
          (button) => {
            const index =
              Number(
                button.dataset
                  .optionIndex
              );

            const value =
              button.dataset
                .optionValue;

            const exists =
              this.data.variants.some(
                (variant) => {
                  if (!variant.available) {
                    return false;
                  }

                  return variant.options.every(
                    (
                      option,
                      variantIndex
                    ) => {
                      if (
                        variantIndex
                        === index
                      ) {
                        return (
                          option
                          === value
                        );
                      }

                      const selected =
                        this.selectedOptions[
                          variantIndex
                        ];

                      if (!selected) {
                        return true;
                      }

                      return (
                        option
                        === selected
                      );
                    }
                  );
                }
              );

            button.disabled =
              !exists;

            button.classList.toggle(
              'is-unavailable',
              !exists
            );
          }
        );
    }


    /* =====================================================
       ADD TO CART
    ===================================================== */

    static bindAddEvent() {
      const button =
        this.modal.querySelector(
          '[data-nd-quick-add-add]'
        );

      button?.addEventListener(
        'click',
        () => {
          this.addToCart();
        }
      );
    }


    static async addToCart() {
      const variant =
        this.currentVariant;

      if (
        !variant
        || !variant.available
      ) {
        return;
      }

      const button =
        this.modal.querySelector(
          '[data-nd-quick-add-add]'
        );

      const text =
        this.modal.querySelector(
          '[data-nd-quick-add-add-text]'
        );

      const spinner =
        this.modal.querySelector(
          '[data-nd-quick-add-spinner]'
        );

      button.disabled =
        true;

      if (text) {
        text.textContent =
          'Agregando…';
      }

      if (spinner) {
        spinner.hidden =
          false;
      }

      const root =
        window.Shopify
          ?.routes
          ?.root
        || '/';

      try {
        const response =
          await fetch(
            `${root}cart/add.js`,
            {
              method:
                'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json'
              },

              body:
                JSON.stringify({
                  items: [
                    {
                      id:
                        variant.id,

                      quantity:
                        1
                    }
                  ]
                })
            }
          );

        const result =
          await response.json();

        if (!response.ok) {
          throw new Error(
            result.description
            || result.message
            || 'No fue posible agregar.'
          );
        }

        if (text) {
          text.textContent =
            'Agregado ✓';
        }

        if (spinner) {
          spinner.hidden =
            true;
        }

        await this.dispatchCartUpdate(
          result
        );

        window.setTimeout(
          () => {
            this.close();
          },
          650
        );

      } catch (error) {
        console.error(
          '[Nodara Quick Add] Error agregando producto.',
          error
        );

        if (spinner) {
          spinner.hidden =
            true;
        }

        if (text) {
          text.textContent =
            'Reintentar';
        }

        button.disabled =
          false;
      }
    }


    static async dispatchCartUpdate(
      addedItem
    ) {
      const root =
        window.Shopify
          ?.routes
          ?.root
        || '/';

      let cart =
        null;

      try {
        const response =
          await fetch(
            `${root}cart.js`,
            {
              headers: {
                Accept:
                  'application/json'
              }
            }
          );

        if (response.ok) {
          cart =
            await response.json();
        }
      } catch (error) {
        console.warn(
          '[Nodara Quick Add] No fue posible leer el carro.',
          error
        );
      }

      document.dispatchEvent(
        new CustomEvent(
          'cart:update',
          {
            bubbles:
              true,

            detail: {
              data: {
                itemCount:
                  cart?.item_count
                  ?? 1,

                source:
                  'nodara-quick-add',

                cart,
                addedItem
              }
            }
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'nodara:cart-update',
          {
            bubbles:
              true,

            detail: {
              cart,
              addedItem
            }
          }
        )
      );
    }


    /* =====================================================
       HELPERS
    ===================================================== */

    static normalizeSize(
      value
    ) {
      return String(
        value
      )
        .toLowerCase()
        .trim()
        .replace(
          /×/g,
          'x'
        )
        .replace(
          /\s+/g,
          ''
        )
        .replace(
          /cm/g,
          ''
        );
    }


    static formatMoney(
      cents
    ) {
      const value =
        Number(
          cents
        ) / 100;

      const currency =
        window.Shopify
          ?.currency
          ?.active
        || 'CLP';

      try {
        return new Intl.NumberFormat(
          'es-CL',
          {
            style:
              'currency',

            currency,

            maximumFractionDigits:
              currency === 'CLP'
                ? 0
                : 2
          }
        ).format(
          value
        );
      } catch {
        return `$${Math.round(
          value
        ).toLocaleString(
          'es-CL'
        )}`;
      }
    }


    static escapeHtml(
      value
    ) {
      const div =
        document.createElement(
          'div'
        );

      div.textContent =
        String(
          value
          ?? ''
        );

      return div.innerHTML;
    }
  }


  if (
    !customElements.get(
      'nd-quick-add'
    )
  ) {
    customElements.define(
      'nd-quick-add',
      NodaraQuickAdd
    );
  }
})();